import React from 'react'
import { useLocation } from 'react-router-dom'

import SuiteStaffDetails from '../../containers/Staff/Details'
import Layout from '../../components/Layout'

export const SuiteDetails = () => {
  const location = useLocation()
  const currentPath = location.pathname
  const title = currentPath === '/staff/new'
    ? 'New staff settings'
    : 'Edit Staff Settings'

  return (
    <Layout
      backTo='/staff'
      iconType='back'
      isSidebar={true}
      title={title}>
      <SuiteStaffDetails  />
    </Layout>
  )
}

export default SuiteDetails
